module.exports = __webpack_public_path__ + "img/SnowRain.7fbb286c.png";